import styled from '@emotion/styled'
import { AnimatedTitle } from 'app/components/Common/Animation/AnimatedTitle'
import { FadeInUp } from 'app/components/Common/Animation/FadeInUp'
import { Button, Props as ButtonProps } from 'app/components/Common/Button'
import { styles } from 'app/theme'
import React, { memo } from 'react'

export interface Props {
  ctas?: ButtonProps[]
  description?: string
  label?: string
  title?: string
}

export const Paragraph = memo(function Paragraph({
  ctas,
  description,
  label,
  title,
}: Props) {
  return (
    <Container>
      {label ? (
        <FadeInUp>
          <Label>{label}</Label>
        </FadeInUp>
      ) : null}

      {title ? <Title tag="h3" text={title} /> : null}

      {description ? (
        <FadeInUp>
          <Description dangerouslySetInnerHTML={{ __html: description }} />
        </FadeInUp>
      ) : null}

      {ctas ? (
        <Buttons>
          {ctas.map((item, index) => (
            <FadeInUp key={index}>
              <CTA variant="flat" {...item} />
            </FadeInUp>
          ))}
        </Buttons>
      ) : null}
    </Container>
  )
})

const Container = styled.section`
  margin-top: 10rem;
  padding: 0 2rem;
  text-align: center;

  @media (max-width: 1199px) {
    margin-top: 5.25rem;
  }
`

const Label = styled.h2`
  ${styles.label}
`

const Title = styled(AnimatedTitle)`
  ${styles.title.large}
`

const Description = styled.div`
  ${styles.description}

  max-width: 53rem;
  margin: 1.5rem auto 0;

  @media (max-width: 1199px) {
    max-width: none;
  }
`

const Buttons = styled.div`
  margin-top: 3.75rem;

  > div {
    margin-top: 1.5rem;
    &:first-of-type {
      margin-top: 0;
    }
  }
`

const CTA = styled(Button)``
